import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/bundles-in-vinted';

export default function Example() {
  return (
    <>
      <Head>
        <title>Vinted Sellers, Here's How You Can Boost Sales With Bundles</title>
        <meta
          name='description'
          content='Knowing the ins and outs may be overwhelming, but there are a couple of simple yet effective ways to boost your sales without having to research so much. These are creating Item Bundles and doing Item Bumps.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/bundles-in-vinted' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/bundles-in-vinted' />
        <meta property='og:title' content="Vinted Sellers, Here's How You Can Boost Sales With Bundles" />
        <meta
          property='og:description'
          content='Knowing the ins and outs may be overwhelming, but there are a couple of simple yet effective ways to boost your sales without having to research so much. These are creating Item Bundles and doing Item Bumps.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Vinted' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
